module.exports = __webpack_public_path__ + "img/__Dashboard.ae9c8a8b.svg";